import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function PGGlobalCash({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const navigate = useNavigate();
	const { promotionsData } = usePromotionsData();
	const data = promotionsData.find(
		(promo) => promo.title === "PGSoft Global Cash",
	);
	const [isMobile, setIsMobile] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	useEffect(() => {
		const loggedInState = localStorage.getItem("isLoggedIn") === "true";
		setIsLoggedIn(loggedInState);
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	//If the promo page is expired - throws error
	useEffect(() => {
		if (!data) {
			navigate("/not-found");
		}
	}, [data, navigate]);

	if (!data) return null;
	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>PGSoft Global Cash Tournament</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions
							</a>{" "}
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH ${data.title}`}
							/>
						</div>
						<div className="promotion-tnc-content">
							<div className="promotion-tnc-info">
								<div
									className={`promotion-indication-message ${data.promotionMessage.class}`}
								>
									{data.promotionMessage.text}
								</div>
								<h1>PGSoft Global Cash</h1>
								<h2>Worth USD 300,000</h2>
								<div className="promotion-tnc-period">
									<strong>Event Period: </strong>
									<span>June 01 - June 30, 2026 (GMT-3)</span>
								</div>
							</div>
							<div className="promotion-tnc-mechanic-content">
								{!isAppPromo && (
									<div className="promotion-tnc-btn-wrapper">
										<a
											href="/slots/?provider=PGSOFT"
											className="promotion-cta-btn"
											style={{ cursor: "pointer" }}
										>
											Play Now
										</a>
									</div>
								)}
								<strong>Selected Games: </strong>
								<ol>
									<li>
										<p>
											All PG Soft games{" "}
											<strong className="highlight">
												Except table games.
											</strong>{" "}
										</p>
									</li>
								</ol>
								<strong>How it works: </strong>
								<ol>
									<li>
										Play selected games during the{" "}
										<strong className="highlight">“Promotion Period”</strong> to
										participate in the tournament.
									</li>
									<li>
										<p>
											The total cash prize for{" "}
											<strong className="highlight"> ONE </strong> tournament
											(30 days) is{" "}
											<strong className="highlight"> USD 300,000 </strong>
										</p>
									</li>
									<li>
										<p>
											<p>
												The promotion consists of{" "}
												<strong className="highlight"> ONE (1) </strong>{" "}
												tournament.
											</p>
										</p>
									</li>
								</ol>
								<div className="table-wrapper">
									<table className="promotion-tnc-table">
										<thead>
											<th>Tournament</th>
											<th>Tournament Description</th>
											<th>Tournament Start and End Times (GMT +3)</th>
										</thead>
										<tbody>
											<tr>
												<td>Tournament</td>
												<td>Total Bet Amount</td>
												<td>Every day 00:00 – next Day 23:59</td>
											</tr>
										</tbody>
									</table>
								</div>
								<strong> Cash Tournament: </strong>
								<p>
									A total DAILY cash prizes worth USD 300,000 for this
									tournament.
								</p>
								<div className="table-wrapper">
									<table
										className="promotion-tnc-table"
										style={{ minWidth: "0px" }}
									>
										<thead>
											<tr>
												<th rowSpan={2}>Tournament</th>
												<th rowSpan={2}>Ranking</th>
												<th colSpan={2}>Daily Cash Prize (USD)</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td rowSpan={7}>1 & 2</td>
												<td>1st</td>
												<td>530</td>
											</tr>
											<tr>
												<td>2nd</td>
												<td>340</td>
											</tr>
											<tr>
												<td>3rd</td>
												<td>212</td>
											</tr>
											<tr>
												<td>4th – 10th</td>
												<td>124</td>
											</tr>
											<tr>
												<td>11th – 50th</td>
												<td>90</td>
											</tr>
											<tr>
												<td>51st – 100th</td>
												<td>45</td>
											</tr>
											<tr>
												<td>101st – 200th</td>
												<td>22</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div className="promotion-tnc-cta">
									<a
										className="promotion-cta-btn"
										href="https://public.pg-demo.com/events/jun/brl-usd/?l=en"
										target="_blank"
										rel="noreferrer"
									>
										View Full T&C
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
